import Swiper, { Lazy, Navigation } from "swiper";

const SinglePost = {
  init() {
    SinglePost.events();
    SinglePost.related();
  },

  events() {
    $("body").on("click", ".soc-share", function (e) {
      e.preventDefault();

      let url = $(this).attr("href");

      helpers.share(url);
    });
  },

  related() {
    const newsEl = $(".news-posts");
    if (!newsEl.length) {
      return;
    }

    const navPrev = newsEl.find(".swiper-button-prev");
    const navNext = newsEl.find(".swiper-button-next");

    new Swiper(newsEl.find(".news-slider")[0], {
      slidesPerView: 3,
      spaceBetween: 88,
      modules: [Lazy, Navigation],
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 3,
      },
      navigation: {
        prevEl: navPrev[0],
        nextEl: navNext[0],
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        600: {
          slidesPerView: 2,
        },
        900: {
          slidesPerView: 3,
        },
      },
    });
  },
};

export default SinglePost;
